import { SiteRecceStatusEnum } from '@api/enum';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { SiteRecceByStatusList } from 'modules/site-recce/components/SiteRecceByStatusList/SiteRecceByStatusList';
import { useSearchParams } from 'react-router-dom';

const AllSiteReccePage = () => {
    const [searchParams] = useSearchParams();

    // Get status from query param and fallback to UNASSIGNED if not present
    const status = (searchParams.get('status') as SiteRecceStatusEnum) || SiteRecceStatusEnum.UNASSIGNED;

    return (
        <PageTemplate className="">
            <div className="flex justify-between ">
                <PageHeading>{status.charAt(0) + status.slice(1).toLowerCase()} Recce List</PageHeading>
            </div>

            <SiteRecceByStatusList status={status} />
        </PageTemplate>
    );
};

export default AllSiteReccePage;
